<template>
  <TableBodyRow
    :id="`saved-solutions_table_row_${index}`"
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr"
    :class="{ gw_table_body_row_active: isActive }"
    @click="handleApplyClick"
  >
    <TableBodyCell
      style="--max-width-td: 6rem; --min-width-td: 6rem; --padding-td: 0; justify-content: center"
      @click.stop
    >
      <div
        class="d-flex"
        style="gap: 0.5rem"
      >
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-primary);
          "
          :value="isSelected"
          @click="$emit('toggle:selected')"
        >
          <template #content>
            <div
              class="csst_content clr-white"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t('common.select')"
            />
          </template>
        </Checkbox>
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          :value="item.is_favorite"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-yellow);
          "
          :icons="['mdi-star-outline', 'mdi-star']"
          @click="$emit('toggle:favorite')"
        >
          <template #content>
            <div
              class="csst_content clr-white text-nowrap"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t(`common.${item.is_favorite ? 'starred' : 'not_starred'}`)"
            />
          </template>
        </Checkbox>
        <Checkbox
          class="csst csst_nm flgmfslctr_title_controls_item"
          style="
            --icon-size: 1.25rem;
            --clr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-yellow);
          "
          :icons="['mdi-information-outline', 'mdi-information-outline']"
          @click="e => $emit('show:detail', { e, item })"
        >
          <template #content>
            <div
              class="csst_content clr-white text-nowrap"
              style="line-height: 1.2; left: calc(100% + 0.5rem)"
              v-html="$t('tooltips.show_info')"
            />
          </template>
        </Checkbox>
      </div>
    </TableBodyCell>

    <TableBodyCell
      thKey="name"
      style="--padding-td: 0 0.5rem 0 0.25rem"
      @click.stop
    >
      <GwTableInputMenu
        :text="item.name || ''"
        @confirm="text => patchName(text)"
      >
        <template #text>
          <div
            v-if="item.name"
            class="truncate"
            :title="item.name"
          >
            {{ item.name }}
          </div>
          <div
            v-else
            class="clr-grey truncate"
          >
            {{ $t('common.solution_name') }}
          </div>
        </template>
      </GwTableInputMenu>
    </TableBodyCell>

    <TableBodyCell thKey="positions">
      <div
        v-if="$store?.getters?.user_has_flag?.('SOL_3WAY')"
        class="truncate text-medium"
        v-html="
          item.custom_tree.players
            .map(p => getPlayerHtmlPosition(p.display_position))
            .sort()
            .join($t('solfigr.vs'))
        "
      ></div>
      <div
        v-else
        class="truncate"
        v-html="
          $t(`solfigr.oop_vs_ip`, {
            oop: getPlayerHtmlPosition(item.custom_tree.players[0].display_position),
            ip: getPlayerHtmlPosition(item.custom_tree.players[1].display_position),
          })
        "
      ></div>
    </TableBodyCell>

    <TableBodyCell thKey="board">
      <CardRowSimple :cards="getCards(item.board || '')" />
      <template v-if="item.node_locks_count">
        <div class="mdi mdi-lock ml-1" />
        <div class="text-medium weight_500">
          {{ item.node_locks_count }}
        </div>
      </template>
    </TableBodyCell>

    <TableBodyCell thKey="tags">
      <GwMenu
        placement="bottom-start"
        :flOptions="{ offset: 0, padding: 0 }"
        class="w-100"
        :ignoreDataGwmenu="true"
        @click.stop
      >
        <template #opener>
          <TagsTableCellList
            class="gw_btn_hover_back w-100"
            :tags="item.tags"
          />
        </template>
        <template #default>
          <TagsManager
            data-gwmenu="noclose"
            style="box-shadow: var(--menu-shadow)"
            :inputAutofocus="!mobile"
            :tagIds="item.tags.map(t => t.id)"
            :tagType="tagType"
            :allTags="allTags"
            :hasAnyAll="false"
            @click:tag="tag => $emit('click:tag_item', tag)"
          />
        </template>
      </GwMenu>
    </TableBodyCell>

    <TableBodyCell thKey="actions">
      <StreetActionsCompacted
        v-if="item.actions"
        :streets="item.actions"
      />
      <div
        class="gw_btn text-medium weight_500 gw_hvr_content"
        style="position: absolute; right: 0.25rem"
      >
        <div class="mdi mdi-chevron-double-right mr-1"></div>
        {{ $t('btn.apply') }}
      </div>
    </TableBodyCell>
    <!-- <TableBodyCell thKey="spacer"> </TableBodyCell> -->
  </TableBodyRow>
</template>

<script>
import StreetActionsCompacted from '@/components/StreetActionsCompacted/StreetActionsCompacted'
import TagsManager from '@/components/TagsManager/TagsManager'
import TagsTableCellList from '@/components/TagsManager/TagsTableCellList'
import GwMenu from '@/components/lib/GwMenu'
import CardRowSimple from '@/components/CardRow/CardRowSimple'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import GwTableInputMenu from '@/components/DataTables/v2/GwTableInputMenu'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'CustomSolutionsTableRow',

  components: {
    TableBodyRow,
    TableBodyCell,
    StreetActionsCompacted,
    TagsManager,
    TagsTableCellList,
    GwMenu,
    CardRowSimple,
    Checkbox,
    GwTableInputMenu,
  },
  mixins: [table_mix, float_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    mobile: Boolean,
    allTags: Array,
    tagType: String,

    isActive: Boolean,
    isSelected: Boolean,
  },
  emits: [
    'toggle:selected',
    'toggle:favorite',
    'show:detail',
    'click:tag_item',
    'patch:name',
    'drag:start',
    'apply:item',
  ],
  data() {
    return {
      canDelete: false,
    }
  },
  methods: {
    patchName(text) {
      this.$emit('patch:name', { item: this.item, name: text })
    },
    handleApplyClick() {
      this.$emit('apply:item', this.item)
    },
  },
}
</script>
